'use client';

import { useState } from 'react';
import { Mail, ArrowRight, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useSignInModal } from '@/lib/ui';

interface SignInEmailStartProps {
  className?: string;
  buttonLabel?: React.ReactNode;
  redirectTo?: string;
}

export function SignInEmailStart({ className, buttonLabel, redirectTo }: SignInEmailStartProps) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showSignInModal } = useSignInModal();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    showSignInModal({
      title: 'Get started with Sizzle',
      initialEmail: email.trim(),
      autoSubmitEmail: true,
      redirectTo,
    });
    setTimeout(() => setIsSubmitting(false), 500);
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="relative w-full">
          <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSubmitting}
            className="h-11 rounded-xl border-slate-200 bg-white pl-9"
          />
        </div>
        <Button
          type="submit"
          disabled={isSubmitting || !email.trim()}
          className="h-11 w-full cursor-pointer rounded-xl bg-primary-600 px-5 hover:bg-primary-700 sm:w-auto sm:shrink-0"
        >
          {isSubmitting ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              {buttonLabel || 'Sign in'}
              {/* <ArrowRight className="ml-1.5 h-4 w-4" /> */}
            </>
          )}
        </Button>
      </div>
    </form>
  );
}
